export default __webpack_public_path__ + "static/media/schema.86ff917f.graphql";